/*
API requests to the plandem backend
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'
import { API_URL, CKEY } from '../../config'

export const login = (opt) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('POST', '/oauth/token', {...opt}, {noAuth:true, hideErrorMessage:false}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      if(e.data.error == "invalid_request" || e.data.error == "invalid_credentials"){
        reject({'data': 'Ongeldige gebruikersnaam en / of wachtwoord'})
      }
      reject({'data': e.data.error_text})
    })
  })
  return p
}

export const currentUser = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET','/users/current',null,params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const allUsers = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/users`, null,params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const getUser = (data, params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/users/${data.id}`, null,params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const userSwitchTenant = (data) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('PUT', `/users/${data.userId}/tenant/${data.tenantId}`, null,{}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e)
    })
  })
  return p
}

export const searchUsers = (data, params) => {
  var p = new Promise((resolve, reject) => {    
    apiRequest('GET', `/users/search/${data.value}`, null, params).then((res) => {
    
      // add empty pagination object if res.data is empty
      if(!res.data.data || res.data.data.length==0){      
        res.data.meta = {pagination:{count:0,current_page:0,per_page:0,total:0,total_pages:0}}
      }      
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const allUserRolePermissions = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/user-permissions`, null,params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const getPasswordResetRequest = (data) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('POST', `/password/token`, data, {}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const resetUserPassword = (data) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('POST', `/password/reset`, data, {}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const getPasswordChangeToken = (data) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/password/token/${data.token}`, {}, {}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const saveUserFavoriteAssetGroup = (data, params) => {
    let url;
    let method;

    if(!data.userId)
      throw Error('userId is mandatory')

    if(data.id){
      url =  `/users/${data.userId}/favorite-asset-groups/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/users/${data.userId}/favorite-asset-groups`
      method = 'POST'
    }  

    
    var p = new Promise((resolve, reject) => {
      apiRequest(method, url, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e.data)
      })
    })
    return p  
}

export const saveUserFavoriteAsset = (data,params) => {
    let url;
    let method;

    if(!data.userId)
      throw Error('userId is mandatory')

    if(data.id){
      url =  `/users/${data.userId}/favorite-assets/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/users/${data.userId}/favorite-assets`
      method = 'POST'
    }
    console.log("DEZE DATA GAAT ERUIT", data)
    var p = new Promise((resolve, reject) => {
      apiRequest(method, url, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e.data)
      })
    })
    return p
}

export const saveAssetGroupOnRole = (data) => {

  if(!data.userRoleId){
    throw Error('userRoleId is mandatory')
  }

  let url = `/user-roles/${data.userRoleId}/sync-asset-groups`
  let method = "POST"

  var p = new Promise((resolve, reject) => {
    apiRequest(method, url, data,{}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const allUserFavoriteAssets = (data,params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/users/${data.userId}/favorite-assets`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const allUserFavoriteAssetGroups = (data,params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/users/${data.userId}/favorite-asset-groups`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}


export const searchUserRolePermissions = (data, params) => {
  var p = new Promise((resolve, reject) => {    
    apiRequest('GET', `/user-permissions/search/${data.value}`, null, params).then((res) => {
    
      // add empty pagination object if res.data is empty
      if(!res.data.data || res.data.data.length==0){      
        res.data.meta = {pagination:{count:0,current_page:0,per_page:0,total:0,total_pages:0}}
      }      
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const syncUserRolePermissions = (data) => {

  var p = new Promise((resolve, reject) => {

    if(!data.roleId){
      throw Error("roleId is mandatory")
    }
    
    let url;
    let method;

    url =  `/user-roles/${data.roleId}/sync-permissions`
    method = 'POST'
  
    apiRequest(method,url, data.permissions, {}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })

  return p
}



export const saveUser = (data, params) => {

  var p = new Promise((resolve, reject) => {
    let url;
    let method;
    if(data.id){
      url =  `/users/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/users`
      method = 'POST'
    }
    apiRequest(method,url, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const saveUserRole = (data, params) => {

  var p = new Promise((resolve, reject) => {
    let url;
    let method;
    if(data.id){
      url =  `/user-roles/${data.id}`
      method = 'PUT'
    }
    else{
      url =  `/user-roles`
      method = 'POST'
    }
    apiRequest(method,url, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}

export const syncUserRoles = (data) => {

  var p = new Promise((resolve, reject) => {
    if(!data.userId){
      throw Error("userId is mandatory")
    }

    let url;
    let method;

    url =  `/users/${data.userId}/sync-roles`
    method = 'POST'
        
    apiRequest(method,url, data.roles, {}).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })

  return p
}

export const allUserRoles = (params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET', `/user-roles`, null, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {
      reject(e.data)
    })
  })
  return p
}